goog.provide("shadow.js.shim.module$dayjs$plugin$weekOfYear");
goog.provide("module$shadow_js_shim_module$dayjs$plugin$weekOfYear");
shadow.js.shim.module$dayjs$plugin$weekOfYear = shadow.js.nativeProvides["dayjs/plugin/weekOfYear"] = require("dayjs/plugin/weekOfYear");
module$shadow_js_shim_module$dayjs$plugin$weekOfYear.default = shadow.js.shim.module$dayjs$plugin$weekOfYear;
